import React, { useRef, useState } from "react";
import Masthead, {
  MastheadMenuButton,
  MastheadTitle,
} from "@amzn/meridian/masthead";
import whsLogo from "src/images/whs-logo.png";
import "./header.scss";
import { Icon, Row, Text } from "@amzn/meridian";
import Menu, { MenuItem } from "@amzn/meridian/menu";
import { useAppDispatch } from "src/store/store";
import { toggleSideMenu, setProfileSheetOpen } from "src/store/uiSlice";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import geopinTokens from "@amzn/meridian-tokens/base/icon/geopin";
import caretDownTokens from "@amzn/meridian-tokens/base/icon/caret-down";
import checkTokens from "@amzn/meridian-tokens/base/icon/check-small";
import { useNavigate } from "react-router-dom";
import {
  REGION_OPTIONS,
  getCurrentRegion,
  buildRegionUrl,
} from "src/utils/regionUtils";

const formatRegionLabel = (value: string): string => {
  const option = REGION_OPTIONS.find((opt) => opt.value === value);
  const label = option ? option.label : value.toUpperCase();
  return `${label} (${value.toUpperCase()})`;
};

const header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const regionButtonRef = useRef<HTMLButtonElement>(null);
  const [isRegionMenuOpen, setIsRegionMenuOpen] = useState(false);
  const currentRegion = getCurrentRegion();

  const handleRegionSelect = (value: string) => {
    setIsRegionMenuOpen(false);
    // Same behavior as the Change Region page: switching region reloads the
    // app on that region's host. Selecting the current region is a no-op.
    if (value !== currentRegion) {
      window.location.href = buildRegionUrl(value);
    }
  };

  return (
    <Masthead>
      <Row width={"100%"} alignmentHorizontal="justify">
        <Row spacing={"none"} className="header-logo-wrapper">
          <MastheadMenuButton onClick={() => dispatch(toggleSideMenu())} />
          <MastheadTitle onClick={() => navigate("/")}>
            <Row
              spacing={"200"}
              alignmentVertical="center"
              className="saige-logo-wrapper"
            >
              <Text
                fontFamily="bookerly"
                color="success"
                className="saige-logo"
              >
                SAIGE
              </Text>
              <img
                src={whsLogo}
                alt="WHS logo"
                height={24}
                className="whs-logo"
              />
            </Row>
          </MastheadTitle>
        </Row>
        <Row alignmentVertical="center" spacing="200">
          <button
            ref={regionButtonRef}
            className="header-region-trigger"
            onClick={() => setIsRegionMenuOpen(true)}
            aria-label="Select region"
          >
            <Icon tokens={geopinTokens} />
            <Text type="b300" className="header-region-label">
              {formatRegionLabel(currentRegion)}
            </Text>
            <Icon tokens={caretDownTokens} />
          </button>
          <Menu
            id="region-menu"
            anchorNode={regionButtonRef.current}
            open={isRegionMenuOpen}
            position="bottom"
            alignment="end"
            onClose={() => setIsRegionMenuOpen(false)}
          >
            {[...REGION_OPTIONS]
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((option) => (
                <MenuItem
                  key={option.value}
                  iconTokens={
                    option.value === currentRegion ? checkTokens : undefined
                  }
                  onClick={() => handleRegionSelect(option.value)}
                >
                  {formatRegionLabel(option.value)}
                </MenuItem>
              ))}
          </Menu>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => dispatch(setProfileSheetOpen(true))}
          >
            <Icon tokens={userTokens} />
          </div>
        </Row>
      </Row>
    </Masthead>
  );
};
export default header;
